import {
  api,
  storeTokens,
  clearTokens,
  getStoredAuthUser,
} from "./apiClient";
import { API_PATHS } from "../config/api";

function clearUserScopedSessionCaches() {
  if (typeof window === "undefined") return;
  for (let index = window.sessionStorage.length - 1; index >= 0; index -= 1) {
    const key = window.sessionStorage.key(index);
    if (key?.startsWith("sales-dashboard-")) window.sessionStorage.removeItem(key);
  }
}

export async function loginRequest({ username, password }) {
  const res = await api.post(API_PATHS.login, { username, password });
  const { access } = res.data || {};
  if (!access) throw new Error("No access token returned from server.");
  storeTokens({ access });
  return res.data;
}

export async function logoutRequest() {
  clearTokens();
  clearUserScopedSessionCaches();
  try {
    await api.post(API_PATHS.logout, {});
  } catch {
    // 로컬 토큰은 이미 지웠으므로 서버 쿠키 삭제 실패는 조용히 무시한다.
  }
}

export function getInitialAuthState() {
  const cachedUser = getStoredAuthUser();
  return {
    hasStoredSession: Boolean(cachedUser),
    // localStorage 사용자 정보는 세션 표식일 뿐이며 /me 성공 전에는 인증하지 않는다.
    isAuthenticated: false,
    user: null,
  };
}
